<!-- Primary toolbar -->
<mat-toolbar color="primary" class="h-[72px]">
  <div class="toolbar-inner">
    <img [src]="companyLogoSrc" alt="" width="91" height="32" />
    <div class="toolbar-links desktop-nav" aria-label="Main navigation">
      @for (header of headers; track trackByHeaders($index, header)) {
        @if (header && !!headerItemTemplates[header]) {
          <ng-container
            *ngTemplateOutlet="
              headerItemTemplates[header]!;
              context: { $implicit: header }
            "
          ></ng-container>
        }
      }
    </div>

    @if (showMenuButton) {
      <button
        type="button"
        class="mobile-nav-toggle"
        mat-stroked-button
        [matMenuTriggerFor]="mobileNavigationMenu"
        aria-label="Open navigation menu"
      >
        Menu
      </button>

      <mat-menu #mobileNavigationMenu="matMenu" class="mobile-nav-menu">
        @for (header of headers; track trackByHeaders($index, header)) {
          @if (header && !!headerItemTemplates[header]) {
            <div class="mobile-nav-item">
              <ng-container
                *ngTemplateOutlet="
                  headerItemTemplates[header]!;
                  context: { $implicit: header }
                "
              ></ng-container>
            </div>
          }
        }
      </mat-menu>
    }
    <div class="flex-1"></div>
    <ng-content></ng-content>
  </div>
</mat-toolbar>
<!-- Secondary toolbar -->
@if (showSublinks && subLinkTemplate) {
  <mat-toolbar
    class="h-14 bg-white border-b border-b-gray-300"
    style="background-color: white; border-bottom-style: solid"
  >
    <div class="toolbar-inner toolbar-sublinks">
      <ng-container *ngTemplateOutlet="subLinkTemplate"></ng-container>
    </div>
  </mat-toolbar>
}
